import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { formatTimeFromSeconds } from '../../../core/util';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import startCase from 'lodash/startCase';
import Tag from '../../../core/layout/Tag';

const MasteryTestList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Mastery Test',
        path: 'index',
        sort: true,
        width: '130px',
      },
      {
        label: 'Group',
        path: 'group',
        sort: true,
        width: '90px',
      },
      {
        label: 'Deadline Time',
        path: 'deadlineTime',
        width: '110px',
        render: (cell, row) => formatTimeFromSeconds(row.deadlineTime),
      },
      {
        label: 'Score to Pass',
        path: 'scoreToPass',
        width: '110px',
      },
      {
        label: 'Items Count',
        path: 'itemsCount',
        width: '105px',
      },
      {
        label: 'Items with audio',
        path: 'itemsWithAudio',
        width: '120px',
        render: (cell, row) => (row.itemsThatNeedAudio ? `${cell}/${row.itemsThatNeedAudio}` : 'N/A'),
      },
      {
        label: 'Items with image',
        path: 'itemsWithImage',
        width: '120px',
        render: (cell, row) => (row.itemsThatNeedImage ? `${cell}/${row.itemsThatNeedImage}` : 'N/A'),
      },
      {
        label: 'Grammars',
        path: 'grammars',
        render: (value) =>
          !value || !value.length
            ? 'No grammars found'
            : value.reduce((aac, g, index) => aac.concat(index ? ', ' : '').concat(`${g.name} (${g.count} items)`), ''),
      },
      {
        label: 'Status',
        path: 'status',
        width: '120px',
        render: (cell) =>
          cell && (
            <Tag color={{ DRAFT: 'grey', PUBLISHED: 'green', UNPUBLISHED: 'red' }[cell]}>
              {startCase(cell.toLowerCase())}
            </Tag>
          ),
      },
      {
        label: 'Actions',
        path: 'action',
        width: '125px',
        render: (cell, row) => {
          return (
            <div>
              {row.status === 'DRAFT' && !row.itemsCount && (
                <>
                  <Button icon="delete" onClick={() => props.onDelete(row.module.id, row.id)} tooltip="Remove" />{' '}
                </>
              )}
              <Button
                icon="edit"
                tooltip="Edit info"
                onClick={() => browserHistory.push(`/modules/${row.module.id}/mastery-tests/${row.id}`)}
              />{' '}
              {!!row.itemsCount && (
                <>
                  <form
                    action={`${process.env.REACT_APP_STUDENT_API_URL}/public/tasting`}
                    target="_blank"
                    method="post"
                    style={{ display: 'inline-block' }}
                  >
                    <input type="hidden" name="function" value="mastery" />
                    <input type="hidden" name="locale" value="pt-br" />
                    <input type="hidden" name="course" value={row.module.course} />
                    <input type="hidden" name="module" value={row.module.id} />
                    <input type="hidden" name="masteryTest" value={row.id} />
                    <Button icon="select" buttonType="submit" tooltip="Tasting" />
                  </form>{' '}
                </>
              )}
              {['DRAFT', 'UNPUBLISHED'].includes(row.status) &&
                !!row.itemsCount &&
                row.itemsWithImage === row.itemsThatNeedImage &&
                row.itemsWithAudio === row.itemsThatNeedAudio && (
                  <>
                    <Button
                      icon="cloud-upload"
                      buttonType="button"
                      tooltip="Publish"
                      onClick={() => props.onPublish(row.module.id, row)}
                    />{' '}
                  </>
                )}
              {'PUBLISHED' === row.status && (
                <>
                  <Button
                    icon="cloud-download"
                    buttonType="button"
                    tooltip="Unpublish"
                    onClick={() => props.onUnpublish(row.module.id, row)}
                  />{' '}
                </>
              )}
            </div>
          );
        },
      },
    ]}
    rows={props.masteryTests}
  />
);

MasteryTestList.propTypes = {
  masteryTests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      modulePercentageToActive: PropTypes.string.isRequired,
      scoreToPass: PropTypes.number.isRequired,
      module: PropTypes.shape({
        id: PropTypes.string,
      }).isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func,
  onPublish: PropTypes.func.isRequired,
  onUnpublish: PropTypes.func.isRequired,
};

MasteryTestList.defaultProps = {
  onDelete: null,
};

export default MasteryTestList;
